<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fghV6N/tc-custom/9781507300565.jpg?1731883397503" alt="This image is the cover for the book Mindfulness Matters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mindfulness Matters
      </h1>
      <p class="bookDescription body article font2">
        <p>Get the insider’s scoop on how to attain a fully flourishing life. Encompassing deep dives into mind, body, and spirit, you will be introduced to the science of positive psychology, engage with the practice of mindfulness, learn how to build an optimally efficient body, and commit to an elevation of your spirit. This is flourishing in action! Whether struggling with anxiety or depression, searching to fill a missing void, or just interested in everyday self-care, you will learn to identify opportunities for growth and seamlessly integrate life-changing practices into daily habits. Replete with powerful affirmations and practice exercises throughout, you will be able to build the framework that fuels and furthers your evolutionary journey for years to come and changes the trajectory of your life forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pax Tandon
      </h2>
      
      <p class="authorDescription body article">Armed with more degrees than a thermometer and on a mission to give every human being a chance to thrive, Pax Tandon pairs radical candor with a trusting tone to motivate and inspire audiences around the world to lead flourishing lives.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing, Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c77dd17